var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useAccountByIdQuery } from "./accountGQL";
import { UNITS } from "../units";
var extractAccountData = function (data) {
    var _a, _b, _c, _d, _e, _f, _g;
    var timeZone = ((_a = data === null || data === void 0 ? void 0 : data.account) === null || _a === void 0 ? void 0 : _a.defaultTimeZone) || "";
    var account = (data === null || data === void 0 ? void 0 : data.account)
        ? { id: data.account.id, name: data.account.name }
        : { id: 0, name: "" };
    var loadSizeUnit = (_b = data === null || data === void 0 ? void 0 : data.account) === null || _b === void 0 ? void 0 : _b.loadSizeUnit;
    var waterVolumeUnit = (_c = data === null || data === void 0 ? void 0 : data.account) === null || _c === void 0 ? void 0 : _c.waterUnit;
    var waterRatioUnit = waterVolumeUnit && loadSizeUnit
        ? "".concat(waterVolumeUnit, "/").concat(loadSizeUnit)
        : undefined;
    var admixVolumeUnit = (_d = data === null || data === void 0 ? void 0 : data.account) === null || _d === void 0 ? void 0 : _d.admixUnit;
    var admixRatioUnit = admixVolumeUnit && loadSizeUnit
        ? "".concat(admixVolumeUnit, "/").concat(loadSizeUnit)
        : undefined;
    var temperature = (_e = data === null || data === void 0 ? void 0 : data.account) === null || _e === void 0 ? void 0 : _e.temperatureUnit;
    var units = {
        admixRatioUnit: (admixRatioUnit && UNITS[admixRatioUnit]) || "",
        loadSizeUnit: (loadSizeUnit && UNITS[loadSizeUnit]) || "",
        slumpUnit: ((_f = data === null || data === void 0 ? void 0 : data.account) === null || _f === void 0 ? void 0 : _f.slumpUnit) || "",
        speedUnit: ((_g = data === null || data === void 0 ? void 0 : data.account) === null || _g === void 0 ? void 0 : _g.speedUnit) || "",
        temperatureUnit: (temperature && UNITS[temperature]) || "",
        waterRatioUnit: (waterRatioUnit && UNITS[waterRatioUnit]) || "",
        waterVolumeUnit: waterVolumeUnit || "",
    };
    return { timeZone: timeZone, account: account, units: units };
};
export default (function (accountId) {
    var _a = useAccountByIdQuery({
        skip: !accountId,
        variables: { accountId: accountId },
    }), data = _a.data, error = _a.error;
    return __assign({ error: error }, extractAccountData(data));
});
//# sourceMappingURL=useQueryAccountById.js.map